import React from "react";
import ItineraryHubPage from "@/components/ItineraryHubPage";
import { HUB_GRANSUR_FEZ_RAK } from "@/lib/itineraryHubs";
export default function GransurFezRakHubPage() {
  return <ItineraryHubPage hub={HUB_GRANSUR_FEZ_RAK} />;
}
